import React, { useState } from 'react';

/**
 * Repo: PWT-PlatformUI
 *
 * Sites: RGS
 *
 * @description Limited search field with no autocomplete or suggestions.
 * Uses local state and initialValue props.
 *
 */
const EntryFormSearchField = ({
  handleKeyDown,
  handleChange,
  handleBlur,
  initialValue,
  id,
  className,
  placeholder,
}) => {
  const [value, setValue] = useState(initialValue);

  return (
    <div className={`${className}__field-container`}>
      <input
        value={value}
        onKeyDown={(e) => handleKeyDown(e)}
        onChange={(e) => {
          setValue(e.target.value);
          if (typeof handleChange === 'function') {
            handleChange(e);
          }
        }}
        onBlur={(e) => handleBlur(e)}
        type="text"
        id={id}
        name="q"
        placeholder={placeholder}
        className={`${className}__field__query`}
      />
    </div>
  );
};

EntryFormSearchField.defaultProps = {
  handleKeyDown: () => {},
  handleChange: () => {},
  handleBlur: () => {},
  initialValue: '',
  id: '',
  className: '',
  placeholder: '',
};

export default EntryFormSearchField;
